import LineBedDoubleIcon from 'LuxKit/Icons/line/LineBedDoubleIcon'
import LineClockWithTickIcon from 'LuxKit/Icons/line/LineClockWithTickIcon'
import LineCommentAltIcon from 'LuxKit/Icons/line/LineCommentAltIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import { useIntl } from 'react-intl'

function VillasWhyBookWithUs() {
  const intl = useIntl()
  return (
    <Group direction="vertical" gap={32}>
      <Heading variant="heading2" colour="normal-contrast">
        {intl.formatMessage({
          id: '2YoCLvI_Wc0RZR_r6q11',
          defaultMessage: 'Why you should book with us',
        })}
      </Heading>
      <Group
        gap={24}
        direction="vertical"
        tabletDirection="horizontal"
        horizontalAlign="start"
        tabletHorizontalAlign="space-between"
      >
        <Group direction="vertical" gap={12}>
          <LineBedDoubleIcon size="L" colour="normal-contrast" />
          <Group direction="vertical" gap={4}>
            <BodyText colour="normal-contrast" variant="medium" weight="bold">
              {intl.formatMessage({
                id: '9HoBaULFe1Q_XCy4WbHQ',
                defaultMessage: 'Thousands of handpicked villa stays',
              })}
            </BodyText>
            <BodyText variant="medium" colour="normal-contrast">
              {intl.formatMessage({
                id: 'zTWh82iDWRgNkOZqwsjx',
                defaultMessage: 'Unlock a world of premium villa options, handpicked just for you.',
              })}
            </BodyText>
          </Group>
        </Group>
        <Group direction="vertical" gap={12}>
          <LineClockWithTickIcon size="L" colour="normal-contrast" />
          <Group direction="vertical" gap={4}>
            <BodyText variant="medium" weight="bold" colour="normal-contrast">
              {intl.formatMessage({
                id: 'c9JGRBC0rmlV3IHfeSZl',
                defaultMessage: 'Instant booking confirmation',
              })}
            </BodyText>
            <BodyText variant="medium" colour="normal-contrast">
              {intl.formatMessage({
                id: 'eGoRlLi4LvuTUACd-koc',
                defaultMessage: 'Real-time availability for immediate booking confirmation',
              })}
            </BodyText>
          </Group>
        </Group>
        <Group direction="vertical" gap={12}>
          <LineCommentAltIcon size="L" colour="normal-contrast" />
          <Group direction="vertical" gap={4}>
            <BodyText variant="medium" weight="bold" colour="normal-contrast">
              {intl.formatMessage({
                id: 'Fn_ktaqHqnWHZCNNhs_B',
                defaultMessage: '24/7 customer service',
              })}
            </BodyText>
            <BodyText variant="medium" colour="normal-contrast">
              {intl.formatMessage({
                id: 'JR56hJC2D4B2hBzzZ--Z',
                defaultMessage: 'Round-the-clock support from our dedicated team',
              })}
            </BodyText>
          </Group>
        </Group>
      </Group>
    </Group>
  )
}

export default VillasWhyBookWithUs
